import { render } from "./PaymentPromotions.vue?vue&type=template&id=1927650e"
import script from "./PaymentPromotions.vue?vue&type=script&lang=js"
export * from "./PaymentPromotions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\glenn.degroot\\source\\repos\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__